<div class="flex flex-col gap-2 fixed justify-center items-center w-full pt-4 z-[500]">
    <ng-template #errorPopupTemplate></ng-template>
</div>